import { render, staticRenderFns } from "./auto-save-confirm.vue?vue&type=template&id=35209656&scoped=true"
import script from "./auto-save-confirm.vue?vue&type=script&lang=js"
export * from "./auto-save-confirm.vue?vue&type=script&lang=js"
import style0 from "./auto-save-confirm.vue?vue&type=style&index=0&id=35209656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35209656",
  null
  
)

export default component.exports